<div class=dialog>
  <form form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <h1 mat-dialog-title>ユーザ登録</h1>
    <div mat-dialog-content>
      <div class="row mb-10" *ngIf="scope.message">
        <div class="col-md-12">
          <span class="error small">{{ scope.message }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <input matInput placeholder="E-Mail(USER ID)"  formControlName="email">
            <mat-icon matSuffix>email</mat-icon>
            <mat-error *ngIf="f.controls.email.errors && f.controls.email.errors.required">
              E-Mailは必須です
            </mat-error>
            <mat-error *ngIf="f.controls.email.errors && f.controls.email.errors.email">
              E-Mailの形式が正しくありません
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <input matInput placeholder="password"  formControlName="password">
            <mat-icon matSuffix>vpn_key</mat-icon>
            <mat-error *ngIf="f.controls.password.errors && f.controls.password.errors.required">
              passwordは必須です
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="full-width">
            <input matInput placeholder="名前（氏）" formControlName="familyName">
            <mat-error *ngIf="f.controls.familyName.errors && f.controls.familyName.errors.required">
              氏は必須です
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field class="full-width">
            <input matInput placeholder="名前 (名)" formControlName="firstName">
            <mat-error *ngIf="f.controls.firstName.errors && f.controls.firstName.errors.required">
              名は必須です
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <input matInput placeholder="役職" formControlName="position">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="text-right">
      <button mat-stroked-button [mat-dialog-close]="" >close</button>
      <button mat-stroked-button cdkFocusInitial color="primary" type="submit">更新</button>
    </div>
  </form>
</div>
